import { InputHTMLAttributes } from "react";
import styled from "styled-components";
import { Text } from '@pancakeswap/uikit';

interface SliderLabelProps {
  progress: string;
}

interface StyledInputProps extends InputHTMLAttributes<HTMLInputElement> {
  isMax: boolean;
}

interface DisabledProp {
  disabled?: boolean;
}

const getCursorStyle = ({ disabled = false }: DisabledProp) => {
  return disabled ? "not-allowed" : "cursor";
};

const bunnyHeadMax = `/images/slider_static.png`;
const bunnyHeadMain = `/images/slider_static.png`;
const bunnyButt = "/images/slider.png";

const getBaseThumbStyles = ({ isMax, disabled }: StyledInputProps) => `
  -webkit-appearance: none;
  background: url(${isMax ? bunnyHeadMax : bunnyHeadMain}) no-repeat center;
  // background-color: transparent;
  box-shadow: none;
  border: 0;
  cursor: ${getCursorStyle};
  width: 10px;
  height: 32px;
  margin-top: 9px;
  filter: ${disabled ? "grayscale(100%)" : "none"};
  transform: translate(-2px, -2px);
  transition: 200ms transform;
  &:hover {
    transform: ${disabled ? "scale(1) translate(-2px, -2px)" : "scale(1.1) translate(-1px, -1px)"};
  }
`;

export const SliderLabelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center; // Center the input and percentage sign horizontally
  position: relative; // Positioning context for the percentage sign
`;

export const InputWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const TransparentInput = styled.input`
  width: 60px; 
  text-align: center;
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.colors.primary};
  border-radius: 10px;
  color: white; 
  padding-right: 20px; 

  &:disabled {
    border-color: grey;
    color: #ccc; 
  }

  // Remove the default spinner controls from type="number"
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield; 
`;

export const PercentageSign = styled.span`
  position: absolute;
  right: 8px; 
  color: white; 
  pointer-events: none; 
`;


export const SliderLabel = styled(Text)<SliderLabelProps>`
  bottom: 0;
  
`;

export const BunnyButt = styled.div<DisabledProp>`
  background: url(${bunnyButt}) no-repeat center;
  height: 46px;
  filter: ${({ disabled }) => (disabled ? "grayscale(100%)" : "none")};
  position: absolute;
  width: 0px;
`;

export const BunnySlider = styled.div`
  // position: absolute;
  left: 14px;
  width: 100%;
`;

export const StyledInput = styled.input<StyledInputProps>`
  cursor: ${getCursorStyle};
  height: 32px;
  position: relative;
  ::-webkit-slider-thumb {
    ${getBaseThumbStyles}
  }
  ::-moz-range-thumb {
    ${getBaseThumbStyles}
  }
  ::-ms-thumb {
    ${getBaseThumbStyles}
  }
`;

export const BarBackground = styled.div<DisabledProp>`
  background-color: ${({ theme, disabled }) => theme.colors[disabled ? "textDisabled" : "inputSecondary"]};
  height: 2px;
  position: absolute;
  top: 18px;
  width: 100%;
`;

export const BarProgress = styled.div<DisabledProp>`
  background-color: #431732;
  filter: ${({ disabled }) => (disabled ? "grayscale(100%)" : "none")};
  height: 10px;
  position: absolute;
  top: 15px;
`;
